import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { toastError } from 'src/common/helpers/Notifications';
import ApiConstants from '../../../common/helpers/ApiConstants';
import * as requests from '../../../common/helpers/HTTPRequest';
import Utils from '../../../common/helpers/Utils';
import {
  MISSING_DATA_ACTIONS,
  getMissingDataError,
  getMissingDataSuccess,
} from './actions';

function* getMissingData({ payload }) {
  try {
    console.log('get missing data payload ', payload);

    const url = `${ApiConstants.BASE_URL}${ApiConstants.LOGGER_MISSING_DATA}`;
    const response = yield call(requests.getRequest, url, {});
    yield put(
      getMissingDataSuccess(
        response.map((data) => {
          return {
            loggerName: data.name,
            loggerId: data.deviceId,
            sensorType: Utils.getSensorTypeNameByKey(data.sty),
            groupName: data.groupName,
            activeTimeRange: data.activeTimeRange,
            dataCount: data.dcnt || {},
          };
        })
      )
    );
  } catch (e) {
    console.log(e);
    toastError(e.message);
    yield put(getMissingDataError(e));
  }
}

export function* MissingDataSaga() {
  yield takeLatest(MISSING_DATA_ACTIONS.GET_MISSING_DATA, getMissingData);
}

export default function* rootSaga() {
  yield all([fork(MissingDataSaga)]);
}
